module.exports = __webpack_public_path__ + "img/top_banner03.1705b261.png";